/**
 * @typedef Filter
 * @property {string}          facet Facet key.
 * @property {string|string[]} value Value key.
 */

/**
 * Class for handling filters for an Elasticsearch query in an object-oriented way.
 */
export class ElasticFilters {
	/**
	 * Constructor.
	 */
	constructor() {
		this.all = [];
		this.any = [];
		this.none = [];
	}

	/**
	 * Get the output of the filters.
	 *
	 * @return {Object} Filters object.
	 * @public
	 */
	output() {
		return {
			all: this.all,
			any: this.any,
			none: this.none,
		};
	}

	/**
	 * Parses filters when passed from PHP.
	 *
	 * @param {{all: Array, any: Array, none: Array}} options
	 * @public
	 */
	from( options ) {
		this.all = this.parseFilters( options?.all || [] );
		this.any = this.parseFilters( options?.any || [] );
		this.none = this.parseFilters( options?.none || [] );
	}

	/**
	 * Add required filters.
	 *
	 * @param {Object} filters
	 * @public
	 */
	addRequired( filters ) {
		const all = filters?.all || [];
		const any = filters?.any || [];
		const none = filters?.none || [];
		this.all = [ ...this.all, ...all ];
		this.any = [ ...this.any, ...any ];
		this.none = [ ...this.none, ...none ];
	}

	/**
	 * Parses filters (all, any or none) from an array.
	 *
	 * @param {Filter[]} rawFilters
	 * @private
	 */
	parseFilters( rawFilters ) {
		const filters = [];

		for ( const filter of rawFilters ) {
			const keys = Object.keys( filter );

			if ( keys.length === 0 ) {
				continue;
			}

			// Now go through all keys and values.
			const filtersByKey = {};
			for ( const key of keys ) {
				let values = filter[ key ];

				if ( ! Array.isArray( values ) ) {
					values = [ values ];
				}

				// Skip if there's nothing to push.
				if ( values.length === 0 ) {
					continue;
				}

				filtersByKey[ key ] = values;
			}

			// Check if there's any keys to push
			if ( Object.keys( filtersByKey ).length === 0 ) {
				continue;
			}

			filters.push( filtersByKey );
		}

		return filters;
	}
}

